import { render, staticRenderFns } from "./Login-SSO.vue?vue&type=template&id=22859675&scoped=true"
import script from "./Login-SSO.vue?vue&type=script&lang=js"
export * from "./Login-SSO.vue?vue&type=script&lang=js"
import style0 from "./Login-SSO.vue?vue&type=style&index=0&id=22859675&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22859675",
  null
  
)

export default component.exports